var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsanaIcon = function SvgAsanaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7379 11.7174C15.8615 11.7174 13.5301 14.0489 13.5301 16.925C13.5301 19.8014 15.8615 22.133 18.7379 22.133C21.614 22.133 23.9456 19.8014 23.9456 16.925C23.9456 14.0489 21.614 11.7174 18.7379 11.7174ZM5.20772 11.7178C2.33166 11.7178 0 14.0489 0 16.9253C0 19.8014 2.33166 22.133 5.20772 22.133C8.08396 22.133 10.4157 19.8014 10.4157 16.9253C10.4157 14.0489 8.08396 11.7178 5.20772 11.7178ZM17.1804 5.20763C17.1804 8.08378 14.849 10.4158 11.9729 10.4158C9.09659 10.4158 6.76511 8.08378 6.76511 5.20763C6.76511 2.33166 9.09659 0 11.9729 0C14.849 0 17.1804 2.33166 17.1804 5.20763Z",
    fill: "url(#paint0_radial_1991_502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1991_502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1044 12.0962) scale(15.8671 15.8671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#F95353"
  })))));
};
export { SvgAsanaIcon as ReactComponent };
export default __webpack_public_path__ + "asana-icon.svg";